import React from 'react';

import { ItemDetailCard } from './ItemDetailCard';

export const ItemDetail = ({ item }) => {
  return (
    <>
      <ItemDetailCard item={item} />
    </>
  );
};
